/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FacultyContactInformationAddUpdateDTO
 */
export interface FacultyContactInformationAddUpdateDTO {
	/**
	 *
	 * @type {string}
	 * @memberof FacultyContactInformationAddUpdateDTO
	 */
	contactPersonName?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof FacultyContactInformationAddUpdateDTO
	 */
	email?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof FacultyContactInformationAddUpdateDTO
	 */
	phone?: string | null;
}

export function FacultyContactInformationAddUpdateDTOFromJSON(
	json: any
): FacultyContactInformationAddUpdateDTO {
	return FacultyContactInformationAddUpdateDTOFromJSONTyped(json, false);
}

export function FacultyContactInformationAddUpdateDTOFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): FacultyContactInformationAddUpdateDTO {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		contactPersonName: !exists(json, "contactPersonName")
			? undefined
			: json["contactPersonName"],
		email: !exists(json, "email") ? undefined : json["email"],
		phone: !exists(json, "phone") ? undefined : json["phone"],
	};
}

export function FacultyContactInformationAddUpdateDTOToJSON(
	value?: FacultyContactInformationAddUpdateDTO | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		contactPersonName: value.contactPersonName,
		email: value.email,
		phone: value.phone,
	};
}
